export default __webpack_public_path__ + "static/media/cross-icon.61130714.png";